import { render, staticRenderFns } from "./BRoot.vue?vue&type=template&id=499228c2&"
import script from "./BRoot.vue?vue&type=script&lang=js&"
export * from "./BRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports